// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".review-tags{display:flex;max-width:900px;flex-wrap:wrap;justify-content:flex-end;align-items:center}@media (max-width: 767px){.review-tags{width:100%;justify-content:flex-start}}.review-tags .review-tag{margin-right:var(--space-1);margin-bottom:var(--space-1);margin-top:var(--space-1)}.review-tags .show-more-toggle{margin-left:var(--space-1)}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
